import update from 'immutability-helper';

const initState = {
 merchant_phone: '',
 merchant_address:'',
 merchant_name: '',
 problem:'',
 product_model:'',
 product_category:'',
 service_type:'',
 merchant_province:'',
 merchant_city:'',
 dareMaqaze: false
}

const newAddressReducer = (state = initState, action) =>{
  switch (action.type) {
    case 'SET_NAME' :
      return {...state, merchant_name: action.payload}
    case 'SET_PHONE' :
      return {...state, merchant_phone: action.payload}
    case 'SET_ADDRESS' :
      return {...state, merchant_address: action.payload}
    case 'SET_PROBLEM' :
      return {...state, problem: action.payload}
    case 'SET_TYPE' :
      return {...state, service_type: action.payload}
    case 'SET_CATEGORY' :
      return {...state, product_category: action.payload}
    case 'SET_MODEL' :
      return {...state, product_model: action.payload}
    case 'SET_PROVINCE' :
      return {...state, merchant_province: action.payload}
    case 'SET_CITY' :
      return {...state, merchant_city: action.payload}
    case 'SET_MAQ' :
      return {...state, dareMaqaze: action.payload}
    case 'SAVE' :
      // console.log(state);
      return state;
    default:{
      return state;
    }
  }
}

export default newAddressReducer;
